import '../styles/main.scss'

import React, {Component} from 'react'
import {connectToStore} from './Provider'
import Helmet from 'react-helmet'
import classNames from 'classnames'
import PasswordScreen from './PasswordScreen'

export const TRANSITION_DURATION = 400

class Layout extends Component {
  constructor({pageContext}) {
    super()

    this.state = {
      mounted: false,
    }
  }

  componentDidMount = () => {
    this.setState({mounted: true}) // eslint-disable-line
  }

  render() {
    const {
      children,
      pageContext = {},
      isScrollDisabled,
      hasEnteredSitePassword,
      location,
    } = this.props

    const {passwordProtection = {}, header = {}, footer = {}} = pageContext

    const {mounted} = this.state

    // Render nothing if we're password protected
    if (passwordProtection.enablePassword && !mounted) {
      return <React.Fragment />
    }

    const showPasswordProtection =
      passwordProtection.enablePassword && !hasEnteredSitePassword

    const siteFragment = !showPasswordProtection && (
      <div id="maincontent">{children}</div>
    )

    const passwordPageFragment = showPasswordProtection && (
      <PasswordScreen password={passwordProtection.password} />
    )

    return (
      <React.Fragment>
        <Helmet defaultTitle="EIP Portal" />
        <Helmet>
          <html
            lang="en"
            className={classNames({
              'of--hidden': isScrollDisabled,
            })}
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        {siteFragment}
        {passwordPageFragment}
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({hasEnteredSitePassword}) => ({
  hasEnteredSitePassword,
})

export default connectToStore(mapStateToProps)(Layout)
